let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dDk2I")).then(() => parcelRequire('c7EOd'));